import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) output[i] = rawData.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;
}

export function notificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
    await navigator.serviceWorker.ready;
    return reg;
  } catch (e) {
    return null;
  }
}

export async function getExistingSubscription() {
  if (!("serviceWorker" in navigator)) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function enablePushNotifications() {
  if (!pushSupported()) {
    return { ok: false, reason: "unsupported" };
  }
  if (Notification.permission === "denied") {
    return { ok: false, reason: "denied" };
  }
  // Ask permission if not granted yet
  let perm = Notification.permission;
  if (perm !== "granted") {
    perm = await Notification.requestPermission();
  }
  if (perm !== "granted") {
    return { ok: false, reason: perm };
  }
  // Register SW + subscribe
  const reg = await registerServiceWorker();
  if (!reg) return { ok: false, reason: "sw-failed" };

  const { data: keyData } = await api.get("/push/vapid-key");
  if (!keyData?.public_key) return { ok: false, reason: "no-vapid-key" };
  const appServerKey = urlBase64ToUint8Array(keyData.public_key);

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: appServerKey,
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
  });
  return { ok: true };
}

export async function disablePushNotifications() {
  const sub = await getExistingSubscription();
  if (sub) {
    try {
      const json = sub.toJSON();
      await api.post("/push/unsubscribe", { endpoint: json.endpoint, keys: json.keys });
    } catch { /* ignore */ }
    try { await sub.unsubscribe(); } catch { /* ignore */ }
  }
  return { ok: true };
}
